import { cn } from "../../lib/utils.js";

/** Compact page-size control for campaign table footers (recipients, results). */
export function CampaignTablePageSizeSelect<TSize extends number>({
  value,
  sizes,
  ariaLabel,
  onChange,
  className,
  testId,
}: {
  value: TSize;
  sizes: readonly TSize[];
  ariaLabel: string;
  onChange: (size: TSize) => void;
  className?: string;
  testId?: string;
}): React.JSX.Element {
  return (
    <select
      value={value}
      aria-label={ariaLabel}
      data-testid={testId}
      className={cn(
        "h-8 rounded-md border border-line/70 bg-surface px-2 text-[0.75rem] text-foreground",
        "focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-accent/50",
        className,
      )}
      onChange={(event) => onChange(Number(event.target.value) as TSize)}
    >
      {sizes.map((size) => (
        <option key={size} value={size}>
          {size}
        </option>
      ))}
    </select>
  );
}
